export const list = [
    {
        label: '智驱未来，护航坦途——羿畅科技AI道路病害巡查系统正式上线',
        text: `1月5日，羿畅科技匠心打造AI道路病害巡查系统，在这具有里程碑意义的一天正式上线！本产品以“智驱未来，
        护航坦途”这一富含深意的主题，赋能道路养护行业的变革升级。在城市与乡村的经纬之间，道路犹如国家的血脉，承载着经济发展的脉动和社会生活的顺畅。
        今天，我们向您隆重推介武汉羿畅科技倾力研发的创新成果——AI道路病害巡查系统，为我国的道路养护事业开启智能护航新篇章！`,
        tags: ['AI巡查', '智慧交通'],
        time: '2024-01-05',
        page: '',
        image: require('@/assets/image/newsMedia/enterpriseInfo/img_1.png')
    }, {
        label: '羿畅承建智慧交通管理平台成功助力7地区获得“四好农村路”全国示范区县！',
        text: `2021年11月18日，交通运输部公路局发布关于2021年“四好农村路”全国示范创建结果的公示，
        我司承建的智慧交通管理平台成功助力湖北远安县、钟祥市、孝昌县、咸宁市咸安区，河北广平县、肃宁县、
        三河市共计7个地区获得“四好农村路”全国示范区县！`,
        tags: ['四好农村路', '智慧交通'],
        time: '2021-12-03',
        page: '',
        image: require('@/assets/image/newsMedia/enterpriseInfo/info_1.jpg')
    },
    {
        label: '河北肃宁：数字赋能公路管理，让交通更智能',
        text: `农村公路是农村经济发展的动脉，是农民致富的必经之路。习近平总书记指出，
        “要进一步把农村公路建好、管好、护好、运营好，为广大农民脱贫致富奔小康提供更好的保障。”`,
        tags: ['农村公路', '智慧交通'],
        time: '2021-12-03',
        page: '',
        image: require('@/assets/image/newsMedia/enterpriseInfo/info_2.jpg')
    },
    {
        label: '智慧交通见成效，潜江“四好农村路”建设成果丰硕',
        text: `为全面科学贯彻习近平总书记“把农村公路建好、管好、护好、运营好”的重要指示，
        潜江市制定出台了《潜江市“四好农村路”三年攻坚战行动方案》和《潜江市“四好农村路”发展规划（2018-2022）》。
        2016年至今，累计投入资金7.2亿元，共完成了526公里农村公路提档升级工程，全市农村公路连线成网，
        形成了以干线公路为骨架、县乡公路为动脉、通村公路为纽带的循环公路网。`,
        tags: ['四好农村路', '智慧交通'],
        time: '2021-05-19',
        page: '',
        image: require('@/assets/image/newsMedia/enterpriseInfo/info_3.jpg')
    },
    {
        label: '羿畅科技获得“双软企业”认定，技术实力再升级！',
        text: `近日，羿畅科技获得了由湖北省软件行业协会颁发的“软件企业证书”，加上此前交通大数据可视化平台获得的“软件产品证书”，
        我司至此正式跻身“双软企业”行列。“双软企业”是指软件产品评估和软件企业评估，是衡量一个企业软件研发能力和整体技术实力的重要指标。
        获得“双软”认证，意味着羿畅科技的软件产品设计能力、软件产品质量及软件设计核心关键技术获得了业内的广泛认可。`,
        tags: ['双软企业', '软件企业证书', '软件产品证书'],
        time: '2020-09-28',
        page: '',
        image: require('@/assets/image/newsMedia/enterpriseInfo/info_4.jpg')
    },
    {
        label: '“数智赋能”，助力“四好农村公路”高质量发展！',
        text: `随着我国乡村振兴战略的全面推进，农村公路已基本形成遍布农村、连接城乡的农村公路网络，
        在给我们带来便捷的同时也对管养工作带来了严峻挑战，如何延长农村公路使用寿命，提升养护管理水平，
        促进可持续健康发展，已成为各管养单位亟待解决的问题。羿畅科技专注农村公路信息化建设十余年，
        匠心研发“四好农村路”大数据云平台，通过信息化手段实现农村公路建好、管好、护好、运营好的总体目标，
        为农村公路高质量发展注入“数智动能”。`,
        tags: ['数智赋能', '四好农村公路'],
        time: '2023-05-26',
        page: '',
        image: require('@/assets/image/newsMedia/enterpriseInfo/info_5.png')
    },
    {
        label: '民勤县农村公路自动化检测正式启动！',
        text: `8月28日，由民勤县交通局委托我司对县道423.701km、乡道510.076km、村道156km开展自动化检测，检测比例达40%以上，
        同时对路基、沿线设施同步调查评定，对70座桥梁进行详细调查。我公司高度重视，迅速成立5人项目专项组，由公司技术总监张总任组长，
        负责年报路网分析及内业数据评定技术支撑，由余宇锋任副组长主要负责带领路面自动化检测小组及桥涵调查小组负责外业采集工作。`,
        tags: ['民勤县农村公路自动化检测'],
        time: '2022-09-03',
        page: 'qyzx_6',
        image: require('@/assets/image/newsMedia/enterpriseInfo/info_6.png')
    },
    {
        label: '甘州区农村公路自动化路况及桥涵检测评定工作顺利完成！',
        text: ` 7月23日至8月2日，羿畅科技与山东高速工程检测公司组成联合体，面对甘肃本轮新冠疫情反复的严峻形势，
        在甘州区交通运输局的大力支持下，共克艰难，顺利完成了甘州区2022年农村公路自动化路况及桥涵检测评定工作。截至目前，
        联合体已完成了县、乡道合计734公里的道路检测、48座桥梁、400多座涵洞的调查检评工作，
        标志着甘州区2022年农村公路自动化路况及桥涵检测评定项目外业工作圆满收官。`,
        tags: ['农村公路自动化路况检测', '农村公路自动化桥涵检测'],
        time: '2022-08-02',
        page: '',
        image: require('@/assets/image/newsMedia/enterpriseInfo/info_7.png')
    },
    {
        label: '2022年农村公路技术状况自动化检测项目 第四站-河北涉县检测工作顺利完成',
        text: `涉县交通运输局深入践行交通部及全省关于农村公路自动化检测的工作要求，积极推进农村公路自动化检测工作，
        截止目前全县农村公路管养总里程1367公里，县道34.9公里，乡道 587.8公里，村道744.3公里。对县、乡、村道，
        路面技术状况进行了全覆盖自动化检测，实现 100%自动化检测比例。`,
        tags: ['农村公路技术状况自动化检测'],
        time: '2022-07-16',
        page: '',
        image: require('@/assets/image/newsMedia/enterpriseInfo/info_8.jpg')
    },
    {
        label: '古浪交通：扎实开展农村公路路况自动化检测评定工作',
        text: ` 为全面、准确掌握全县农村公路路况水平，科学指导养护工作，近日，古浪县地方公路管理站委托武汉羿畅科技有限公司，
        对全县农村路况进行了自动化检测。 `,
        tags: ['古浪交通', '农村公路路况自动化检测'],
        time: '2022-07-15',
        page: '',
        image: require('@/assets/image/newsMedia/enterpriseInfo/info_9.png')
    }
];
